import { Button } from "@mui/material";
import awanaLogo from "./awana-logo.png";
import mascotLeft from "./awana-mascot-left.png";
import mascotRight from "./awana-mascot-right.png";
import logoTrek from "./logo-trek.png";
import logoTT from "./awana-images/logo-tt.png";
import edgeBlack from "./edge-black.png";
import edgeRed from "./edge-red.png";
import edgeYellow from "./awana-images/edge-yellow.png";
import edgeGreen from "./awana-images/edge-green.png";
import edgeBlue from "./edge-blue.png";

const REGISTRATION_URL =
  "https://bethelbibleoc.churchcenter.com/registrations/events/3824841";

const Awana = () => {
  return (
    <>
      <style>{`
        .awana-page {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          /* min- (not fixed) height: the page fills exactly the rest of
             the screen below the header when content fits, but on very
             short viewports (mobile landscape especially) the content is
             allowed to make the page taller and scroll rather than get
             clipped. A fixed height here with overflow hidden looked
             fine in portrait but sliced the logo in half in landscape,
             where there's much less room. */
          min-height: calc(100vh - var(--nav-height));
          min-height: calc(100svh - var(--nav-height));
          /* The site's fixed header sits on top of routed page content
             (it's position: fixed, out of normal flow) rather than
             pushing it down, so this top padding - the same --nav-height
             every other page offsets by, plus a little breathing room -
             is what clears it. Using the real custom property instead of
             a guessed pixel value means this stays correct on mobile's
             shorter header too, instead of reserving more space than the
             header actually needs (which was eating into the min-height
             budget above and causing extra scroll). Padding, not margin,
             so it can't collapse into the page wrapper above it. */
          padding: calc(var(--nav-height) + 16px) 24px 48px;
          background: #ffffff;
          box-sizing: border-box;
          /* Shapes bleed off the page's real left/right edges on purpose
             (same as they bleed off the flyer's edges) - clip horizontal
             overflow only, so vertical overflow can still scroll instead
             of ever being cropped. */
          overflow-x: hidden;
        }

        /* The five paint-splash/leaf/ring shapes from the flyer, as small
           corner/edge accents - big enough to read as real decoration,
           small enough to stay out of the hero's way. Each one's anchor
           point sits right at the true edge (top:0/left:0 etc.) and the
           translate() shifts it by a share of ITS OWN size, so the bleed
           stays proportional no matter how big a given shape renders. */
        .awana-bg-shape {
          position: absolute;
          z-index: 0;
          pointer-events: none;
          height: auto;
        }

        .awana-bg-black {
          /* "top" is a plain offset (not part of the transform) so it's
             easy to tune per shape - black and blue have very different
             aspect ratios, so the same offset doesn't clear the header
             by the same amount for both. */
          top: 20px;
          left: 0;
          width: min(24vw, 150px);
          transform: translateX(-30%) rotate(-4deg);
        }

        .awana-bg-blue {
          top: 50px;
          right: 0;
          width: min(22vw, 140px);
          transform: translateX(30%) rotate(6deg) scaleY(-1);
        }

        .awana-bg-green {
          bottom: 0;
          left: 0;
          width: min(20vw, 120px);
          transform: translate(-35%, 10px) rotate(50deg);
        }

        .awana-bg-yellow {
          bottom: 0;
          right: 0;
          width: min(22vw, 130px);
          transform: translate(35%, 20px) rotate(-10deg) scaleX(-1);
        }

        .awana-bg-red {
          bottom: 0;
          left: 50%;
          width: min(40vw, 260px);
          transform: translate(-50%, 22%);
        }

        .awana-hero {
          position: relative;
          z-index: 1;
          /* The 85vh term shrinks the hero (and with it, the logo/text/
             button that scale off its width) on short viewports like
             landscape phones, instead of staying at 82vw and forcing the
             page to scroll a lot vertically. It's high enough that it
             doesn't affect normal portrait or desktop sizing. */
          width: min(720px, 82vw, 85vh);
          /* The logo/text have transparent padding around them, and the
             background shapes are positioned to reach slightly in under
             the hero at some widths - without an opaque backing here,
             black in particular shows through those gaps and blends into
             the logo's own black outline. */
          background: #ffffff;
        }

        .awana-corner {
          position: absolute;
          height: auto;
        }

        .awana-corner-mascot {
          top: -26px;
          left: -4vw;
          width: clamp(54px, 13vw, 140px);
        }

        .awana-corner-trek {
          top: 6px;
          right: -4vw;
          width: clamp(44px, 11vw, 120px);
        }

        .awana-corner-tt {
          /* This asset is portrait (taller than wide), unlike the other
             corner graphics, so it needs a smaller width to avoid
             reaching up into the logo above it. */
          bottom: 6px;
          left: -4vw;
          width: clamp(32px, 7vw, 78px);
        }

        .awana-corner-bear {
          bottom: -12px;
          right: -4vw;
          width: clamp(40px, 11vw, 110px);
        }

        .awana-logo {
          width: 100%;
          height: auto;
        }

        .awana-sr-only {
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          white-space: nowrap;
          border: 0;
        }

        .awana-details {
          position: relative;
          z-index: 1;
          font-family: "Montserrat", -apple-system, BlinkMacSystemFont, sans-serif;
          font-weight: 800;
          text-transform: uppercase;
          color: #FF3131;
          font-size: clamp(18px, 3vw, 28px);
          letter-spacing: 0.02em;
          line-height: 1.4;
          margin: 8px 0 0;
        }

        .awana-cta-wrap {
          position: relative;
          z-index: 1;
          margin-top: clamp(24px, 5vw, 48px);
        }

        .awana-cta {
          font-family: "Montserrat", sans-serif !important;
          font-weight: 800 !important;
          font-size: 16px !important;
          letter-spacing: 0.04em !important;
          color: #000000 !important;
          background-color: #FADF3C !important;
          border: 3px solid #000000 !important;
          border-radius: 10px !important;
          padding: 14px 40px !important;
          box-shadow: 4px 4px 0 #000000 !important;
        }

        @media (max-width: 480px) {
          .awana-corner-mascot, .awana-corner-tt { left: -14px; }
          .awana-corner-trek, .awana-corner-bear { right: -14px; }
        }

        @media (max-height: 500px) {
          /* Landscape phones: claw back vertical space the hero doesn't
             strictly need at this height, and shrink the schedule text -
             the hero itself narrows a lot at this height, and at its
             normal size that line wraps and the bear graphic ends up
             overlapping the wrapped second line. The corner graphics are
             sized off vw normally, which doesn't shrink along with the
             hero's own vh-based width here, so they need their own
             (vh-based) override too or they end up oversized relative to
             the now-narrower hero and overlap the text. This block has
             to come after the base rules above (same specificity -
             source order decides which wins). Top padding keeps the full
             --nav-height clearance (it's already the real value, not a
             guess with room to claw back) and only trims the breathing
             room added on top of it, plus the bottom padding. */
          .awana-page { padding-top: var(--nav-height); padding-bottom: 16px; }
          .awana-details { font-size: clamp(14px, 2.4vw, 19px); }
          .awana-corner-mascot { top: -14px; width: clamp(36px, 9vh, 90px); }
          .awana-corner-trek { width: clamp(30px, 8vh, 80px); }
          .awana-corner-tt { width: clamp(22px, 5vh, 50px); }
          .awana-corner-bear { width: clamp(26px, 7vh, 70px); }
        }
      `}</style>

      <main className="awana-page">
        <h1 className="awana-sr-only">Bethel Bible Church Awana 2026-2027</h1>

        {/* Corner/edge accent shapes, bleeding off the page's real top and
            bottom edges - black/blue at the top corners, green/yellow at
            the bottom corners, red spanning the bottom middle. */}
        <img src={edgeBlack} className="awana-bg-shape awana-bg-black" alt="" aria-hidden="true" />
        <img src={edgeBlue} className="awana-bg-shape awana-bg-blue" alt="" aria-hidden="true" />
        <img src={edgeGreen} className="awana-bg-shape awana-bg-green" alt="" aria-hidden="true" />
        <img src={edgeYellow} className="awana-bg-shape awana-bg-yellow" alt="" aria-hidden="true" />
        <img src={edgeRed} className="awana-bg-shape awana-bg-red" alt="" aria-hidden="true" />

        <div className="awana-hero">
          <img src={mascotLeft} className="awana-corner awana-corner-mascot" alt="" />
          <img src={logoTrek} className="awana-corner awana-corner-trek" alt="" />

          <img
            src={awanaLogo}
            className="awana-logo"
            alt="Bethel Bible Church Awana 2026-2027"
          />

          <p className="awana-details">
            Friday Nights 7:00&ndash;8:30 PM
            <br />
            Ages 3&ndash;14
          </p>

          <img src={logoTT} className="awana-corner awana-corner-tt" alt="" />
          <img src={mascotRight} className="awana-corner awana-corner-bear" alt="" />
        </div>

        <div className="awana-cta-wrap">
          <a href={REGISTRATION_URL} target="_blank" rel="noopener noreferrer">
            <Button variant="contained" size="large" className="awana-cta">
              Sign Up for Awana
            </Button>
          </a>
        </div>
      </main>
    </>
  );
};

export default Awana;
